export const PageNamePlugin = {
  name: 'Page Name',
  version: '1.0.0',
  type: 'enrichment',
  load() {
    return Promise.resolve();
  },
  isLoaded() {
    return true;
  },
  page(ctx) {
    var _ctx$event$properties;
    if (ctx.event.name) {
      return ctx;
    }
    const title = (_ctx$event$properties = ctx.event.properties) === null || _ctx$event$properties === void 0 ? void 0 : _ctx$event$properties['title'];
    if (typeof title === 'string' && title) {
      ctx.event.name = title;
    }
    return ctx;
  }
};
export default PageNamePlugin;